import { Injectable } from '@angular/core';
import { ReportEntryDto } from '@osos/shared/api';
import { ReportPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases';
import { ReportsParserService } from '../../parsers/reports-parser/reports-parser.service';
import { ParserFactory } from '../../services';

@Injectable({
  providedIn: 'root',
})
export class ReportsFactoryService extends FactoryBase<
  ReportEntryDto,
  ReportPresenterModel
> {
  constructor(parserFactory: ParserFactory, parserV1: ReportsParserService) {
    super(parserFactory);
    parserFactory.register(parserV1);
  }

  createPresenterModel(model: ReportEntryDto): ReportPresenterModel {
    const parser = this.getParser(ReportEntryDto, ReportPresenterModel);
    return parser.getPresenterModel(model);
  }
  createDataModel(presenter: ReportPresenterModel): ReportEntryDto {
    const parser = this.getParser(
      ReportEntryDto,
      ReportPresenterModel,
      presenter.specificationVersion,
    );
    return parser.getDataModel(presenter);
  }
}
